import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import StaticPageLayout from "../../components/StaticPageLayout";
import * as styles from "./styles";

type LicenseT = {
  state: string;
  number: string;
  type: string;
};

const licenses: LicenseT[] = [
  { state: "California", number: "1001189", type: "Electrical Contractor (C-10)" },
  { state: "Arizona", number: "ROC335857", type: "Electrical Contractor" },
  { state: "Texas", number: "TECL36867", type: "Electrical Contractor" },
  { state: "Florida", number: "EC13010656", type: "Electrical Contractor" },
  { state: "Nevada", number: "0087622", type: "Electrical Contractor" },
  { state: "Colorado", number: "Exempt", type: "No license required" },
];

type LicensesContentPropsT = {
  t: (key: string) => string;
};

const LicensesContent = ({ t }: LicensesContentPropsT) => (
  <Box sx={styles.pageWrapper}>
    <Box sx={styles.radialGlow} />
    <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Typography variant="overline" sx={styles.eyebrow}>
          {t("hero.eyebrow")}
        </Typography>
        <Typography variant="h1" sx={styles.heading}>
          {t("hero.heading")}
        </Typography>
        <Typography variant="body1" sx={styles.subtitle}>
          {t("hero.subtitle")}
        </Typography>
      </Box>

      <Box sx={styles.glassTableContainer}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={styles.tableHeaderRow}>
                <TableCell sx={styles.tableHeaderCell}>{t("table.columnState")}</TableCell>
                <TableCell sx={styles.tableHeaderCell}>{t("table.columnLicenseNumber")}</TableCell>
                <TableCell sx={styles.tableHeaderCell}>{t("table.columnType")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {licenses.map((lic, index) => (
                <TableRow
                  key={lic.state}
                  sx={{
                    bgcolor: index % 2 === 0 ? "rgba(56,189,248,0.03)" : "transparent",
                    "&:last-child td": { borderBottom: "none" },
                  }}
                >
                  <TableCell sx={styles.tableCell}>{lic.state}</TableCell>
                  <TableCell sx={styles.tableCell}>{lic.number}</TableCell>
                  <TableCell sx={styles.tableCell}>{lic.type}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Typography variant="body2" sx={styles.footerNote}>
        {t("content.footerLead")}{" "}
        <Box component="a" href={`mailto:${t("content.supportEmail")}`} sx={styles.supportEmailLink}>
          {t("content.supportEmail")}
        </Box>
      </Typography>
    </Container>
  </Box>
);

const LicensesPage = () => {
  const { t } = useTranslation("static_licenses");
  return (
    <StaticPageLayout
      title={t("meta.title")}
      description={t("meta.description")}
      canonicalUrl="https://powur.com/licenses"
      ogTitle={t("meta.ogTitle")}
      ogDescription={t("meta.ogDescription")}
      noTopSpacer
    >
      <LicensesContent t={t} />
    </StaticPageLayout>
  );
};

export default LicensesPage;
